<template>
  <div>
		<ts-loading-banner :loading="loading">
			<div class="ts-space-y-3">
				<table class="ts-w-full ts-mt-3">
					<thead>
						<tr>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-48">{{ $t('returnToVendor.stockInNumber') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase">{{ $t('returnToVendor.productGroup') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase">{{ $t('returnToVendor.productName') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase">{{ $t('returnToVendor.productType') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase">{{ $t('returnToVendor.uom') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase">{{ $t('returnToVendor.cost') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-32">{{ $t('returnToVendor.quantity') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-1/4">{{ $t('returnToVendor.remark') }}</th>
							<th class="ts-bg-gray-300 ts-p-2 ts-uppercase ts-w-4">{{ $t('actions') }}</th>
						</tr>
					</thead>
					<tbody>
						<template
							v-for="(detail, mIndex) in model.product_detail"
						>
							<tr
								:key="mIndex"
								class="ts-bg-blue-100"
							>
								<td class="ts-p-2" valign="top">
									<p class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold">{{ detail.stock_in_number }}</p>
								</td>
								<td class="ts-p-2" valign="top">
									<p class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold">{{ detail.pro_group_name_en }}</p>
								</td>
								<td class="ts-p-2" valign="top">
									<p class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold">{{ detail.product_name_en }}</p>
								</td>
								<td class="ts-p-2" valign="top">
									<p class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold">{{ detail.product_type_en }}</p>
								</td>
								<td class="ts-p-2" valign="top">
									<p class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold">{{ detail.uom_name_en }}</p>
								</td>
								<td class="ts-p-2" valign="top">
									<p class="ts-text-blue-500 ts-mb-0 ts-font-hanuman ts-font-bold">{{ detail.cost }}</p>
								</td>
								<td class="ts-p-2" valign="top">
									<input 
										v-model.number="detail.quantity"
										type="number" class="ts-w-full ts-outline-none ts-font-bold ts-p-2 ts-text-blue-500 ts-border ts-border-gray-400 ts-rounded"
										:class="{ 'is-invalid': errors.has('product_detail.' + mIndex + '.quantity')}" 
									>
										<div class="invalid-feedback" v-if="errors.has('product_detail.' + mIndex + '.quantity')">
											{{ errors.first('product_detail.' + mIndex + '.quantity') }}
										</div>
								</td>
								<td class="ts-p-2" valign="top">
									<input v-model.trim="detail.remarks"  type="text" class="ts-w-full ts-outline-none ts-p-2 ts-text-blue-500 ts-border ts-border-gray-400 ts-rounded" placeholder="leave your remark here...">
								</td>
								<td class="ts-p-2 ts-text-center" valign="top">
									<a href="#" class="ts-text-red-600 ts-mt-3"
										@click.prevent="deleteMainProduct(mIndex)"
									><i class="fa fa-trash ts-mt-3"></i></a>
								</td>
							</tr>
							<tr
								v-if="detail.serials.length > 0"
							>
								<td></td>
								<td colspan="6" class="ts-p-2">
									<div class="ts-h-32 ts-border ts-border-blue-300 ts-rounded ts-p-2 ts-space-y-2 ts-space-x-1 ts-overflow-scroll">
										<div class="ts-bg-blue-200 ts-p-2 ts-rounded ts-font-bold w-fit ts-inline-block"
											v-for="(serial, index) in detail.serials"
											:key="serial"
										>
											{{ serial }}
											<span 
												@click.prevent="deleteSerial(mIndex, index)" 
												class="ts-text-red-600 ts-bg-gray-200 ts-px-2 ts-rounded-full ts-cursor-pointer"
												v-tooltip="$t('delete')"	
											>X</span>
										</div>
									</div>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'detailComponent',
	props: ['value', 'validate'],
  data() {
    return {
			loading: false,
			errors: new Errors(),
			model: {},
			row: {
				product_id: null,
				product_name_en: null,
				uom_id: null,
				uom_name_en: null,
				quantity: 0,
				current_qty: 0,
				cost: 0,
				stock_in_id: null,
				stock_in_number: null,
				remarks: null,
				pro_group_name_en: null,
				product_type_en: null,
				serials: []
			}
    }
  },
	created(){
		this.model = this.value
	},
  methods: {
		deleteMainProduct(index){
			this.model.product_detail.splice(index, 1)
		},
		deleteSerial(mainIndex, serialIndex){
				this.model.product_detail[mainIndex].serials.splice(serialIndex, 1)
				this.model.product_detail[mainIndex].quantity = this.model.product_detail[mainIndex].serials.length
		},
  },
	watch: {
		validate: function(error) {
			this.errors = new Errors(error.errors)
		}
	}
}
</script>

<style scoped>
	.w-fit {
		width: fit-content;
	}
</style>
